//Import MUI components
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Box } from "@mui/system";
// Lodash library for utility functions
import _ from "lodash";
// Custom hooks and components from common directory
import { useAuthInfo, ItemRowDetails } from "../../common";

/**
 * SupplierDetails component displays details of suppliers and sample items
 * with interactive functionalities based on user roles.
 * @param {Object} props - Component props including supplier data and callbacks.
 */
export function SupplierDetailsInactiveItem({ supplierValues }) {
  // Fetching user authentication information using custom hook
  let decoded = useAuthInfo();

  // Sorting supplier data by qualityReportsID using lodash
  const sortedSupplierValues = _.orderBy(
    supplierValues,
    ["qualityReportsID"],
    ["asc"]
  );

  // Render the component
  return (
    <Box>
      {/* Render only if supplierValues array has items */}
      {supplierValues.length > 0 && (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <Typography variant="h6" component="h5" gutterBottom mt={4}>
              <b>Sample Details</b>
            </Typography>
          </Grid>
          {/*  Map through sorted supplier values */}
          {sortedSupplierValues.map((obj, index) => {
            //!? TODO: refactor sample data to be reuseable

            // Create supplier Data object
            let supplierData = {
              supplierName: obj.name,
              supplierEmail: obj.email,
            };

            return (
              <Accordion
                sx={{
                  mt: 2,
                  width: "99%",
                }}
                key={index}
              >
                <AccordionSummary
                  //   expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  disabled
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography>
                        Supplier {index + 1}:{" "}
                        {(decoded.role === "sampleControl" ||
                          decoded.role === "sampleControlView" ||
                          decoded.role === "procurement") &&
                          supplierData.supplierName}
                      </Typography>
                      <div style={{ paddingTop: "10px" }}>
                        {" "}
                        {(decoded.role === "sampleControl" ||
                          decoded.role === "sampleControlView" ||
                          decoded.role === "procurement") && (
                          <ItemRowDetails data={supplierData} />
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    style={{
                      fontSize: "18px",
                      marginBottom: "15px",
                      marginTop: "10px",
                    }}
                    gutterBottom
                  ></Typography>
                  {/* Supplier name and email details visible to specific roles */}
                  {(decoded.role === "sampleControl" ||
                    decoded.role === "sampleControlView" ||
                    decoded.role === "procurement") && (
                    <ItemRowDetails data={supplierData} />
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Grid>
      )}
    </Box>
  );
}
